import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";

const Summary = ({ proposalSummary, motorSummary }) => {
  const summary = useSelector((state) => state.common.summary);
  const codesWithPercentage = ["PRMP", "NCDP", "SCHEMEP"];
  return (
    <>
      {!proposalSummary && (
        <div className="row">
          <div className="col-md-6">
            <div className="heading-summ pb-3">{t("MedMal.Summary")}</div>
            <div className="table-sum">
              <table className="table">
                <tbody>
                  {motorSummary?.map((item, i) =>
                    item.category === "summary" && !isNaN(item.price) && +item.price ? (
                      <tr key={"summ_" + i}>
                        <td>{item.label}</td>
                        <div className="sum-tab-left fm-tawuniya">
                          {item.price}{" "}
                          {codesWithPercentage.includes(item.code) || item?.code?.endsWith("R") ? (
                            <span>%</span>
                          ) : (
                            <span>{t("RIGHTFOOTER.SAR")}</span>
                          )}
                        </div>
                      </tr>
                    ) : (
                      ""
                    )
                  )}
                  {/* <tr>
                    <td>Basic Price</td>
                    <td className="sum-tab-left">
                      {summary?.basicPrice} <span>{t("RIGHTFOOTER.SAR")}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Policy fee</td>
                    <td className="sum-tab-left">
                      {summary?.policyFee} <span>{t("RIGHTFOOTER.SAR")}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Additional Coverage</td>
                    <td className="sum-tab-left">
                      {summary?.additionalCoverage}{" "}
                      <span>{t("RIGHTFOOTER.SAR")}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>No Claim Discount (15%)</td>
                    <td className="sum-tab-left">
                      {summary?.noClaimDiscount}{" "}
                      <span>{t("RIGHTFOOTER.SAR")}</span>
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-6">
            <div className="heading-summ pb-3">{t("MedMal.Tax")}</div>
            <div className="table-sum">
              <table className="table">
                <tbody>
                  {motorSummary.map((item, i) =>
                    item.category !== "summary" ? (
                      <tr key={"summ_" + i}>
                        <td>{item.label}</td>
                        <div className="sum-tab-left fm-tawuniya">
                          {item.price}{" "}
                          {item.code === "VATP" ? <span>%</span> : <span>{t("RIGHTFOOTER.SAR")}</span>}
                        </div>
                      </tr>
                    ) : (
                      ""
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-12">
            <hr />
          </div>
        </div>
      )}
      {proposalSummary && (
        <div className="row">
          <div className="col-12">
            <div className="heading-summ pb-3">{t("MedMal.Summary")}</div>
            <div className="table-sum">
              <table className="table">
                <tbody>
                  <tr>
                    <td>{t("MedMal.AmountVAT")}</td>
                    <td className="sum-tab-left fm-tawuniya">
                      {Number(proposalSummary?.amountBeforeTax).toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })}
                      <span> {t("RIGHTFOOTER.SAR")}</span>
                    </td>
                  </tr>
                  {Boolean(proposalSummary?.policyFee) &&
                    <tr>
                      <td>{t("HomeInsurnace.AdminFee")}</td>
                      <td className="sum-tab-left fm-tawuniya">
                        {Number(proposalSummary?.policyFee).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })}
                        <span> {t("RIGHTFOOTER.SAR")}</span>
                      </td>
                    </tr>}
                  <tr>
                    <td>
                      {t("MedMal.VATAmount")} <span className="fm-tawuniya">{proposalSummary?.vatRate ? "(" + proposalSummary.vatRate + "%)" : "(15%)"}</span>
                    </td>
                    <td className="sum-tab-left fm-tawuniya">
                      {Number(proposalSummary?.vatAmount).toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })}
                      <span> {t("RIGHTFOOTER.SAR")}</span>
                    </td>
                  </tr>
                  {Boolean(proposalSummary?.discountPercent) && (
                     <tr>
                      <td>{t("Motor.PRMP")}%</td>
                      <td className="sum-tab-left fm-tawuniya">
                        {Number(proposalSummary?.discountPercent).toLocaleString(undefined, { maximumFractionDigits: 2 })}
                        <span>%</span>
                      </td>
                      </tr>
                  )}
                  {Boolean(proposalSummary?.discountValue) && (
                      <tr>
                      <td>{t("Motor.PRMA")}</td>
                      <td className="sum-tab-left fm-tawuniya">
                        {Number(proposalSummary?.discountValue).toLocaleString(undefined, { maximumFractionDigits: 2 })}
                        <span> {t("RIGHTFOOTER.SAR")}</span>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>{t("SUMMARY.Total")}</td>
                    <td className="sum-tab-left fm-tawuniya">
                      {Number(proposalSummary?.total).toLocaleString(undefined, { maximumFractionDigits: 2 })}
                      <span> {t("RIGHTFOOTER.SAR")}</span>
                    </td>
                  </tr> 
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Summary;
